const ConstantDatas = {
  services: [
    {
      id: 0,
      icon: "phone-laptop",
      title: "Saytların hazırlaması",
      description:
        "İnternet mağazaların, korporativ saytlar, informasiya portallarının və veb-texnologiyalar əsasında hazırlanması.",
      url: "about.html#services",
    },
    {
      id: 1,
      icon: "cogs",
      title: "Saytlara dəstək",
      description:
        "Sizin veb saytlarınızın peşəkar texniki dəstəyini və eləcə də fasiləsiz işini təmin edirik.",
      url: "about.html#services-support-to-websites",
    },
    {
      id: 2,
      icon: "mobile",
      title: "Mobil Əlavələr",
      description:
        "Android və İOS platformalar üzrə mobil əlavələrin yaradılması və  eləcə də tam texniki dəstək.",
      url: "about.html#services-mobile-app",
    },
    {
      id: 3,
      icon: "network-wired",
      title: "BPM, CRM, ERP Sistemlər",
      description:
        "Müştərilərlə işlərin idarə olunması, satış prosesinin avtomatlaşdırılması və s. proseslərin.",
      url: "about.html#services-bpm-crm-erp-systems",
    },
    {
      id: 4,
      icon: "project-diagram",
      title: "B2B,B4B,B2C,C2C,OMS Sistemlər",
      description:
        "Sifaris idare sistemi Anbariniz mevcud olan ve qurtaran mehsullarinizin avtomatlasdirilmis.",
      url: "about.html#services-b2b-b4b-b2c-systems",
    },
    {
      id: 5,
      icon: "disc-drive",
      title: "Saytların optimallaşdırması",
      description:
        "Saytda olan boşluqların, səhvlərin və eləcə də onun işləməsinə çətinlik yaradan məqamların araşdırılması və aradan qaldırılması.",
      url: "about.html#services-website-progress",
    },
  ],
};
